import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FileManagementService } from '../../Services/FileManagementService';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';

const NewFolderModal = ({ show, handleClose, handleCreateFolder, existingFolders }) => {
    const [folderName, setFolderName] = useState('');
    const [error, setError] = useState('');

    useEffect(() => {
        if (show) {
            setFolderName('');
            setError('');
        }
    }, [show]);

    const handleChange = (e) => {
        const name = e.target.value;
        setFolderName(name);

        if (existingFolders.includes(name)) {
            setError('Folder name is already in use');
        } else {
            setError('');
        }
    };

    const handleSubmit = () => {
        if (error || !folderName) return;

        handleCreateFolder(folderName);

        handleClose();
    }

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Create New Folder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="folderName">
                        <Form.Label>Folder Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={folderName}
                            onChange={handleChange}
                            isInvalid={!!error}
                        />
                        <Form.Control.Feedback type="invalid">
                            {error}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={!!error || !folderName}>
                    Create
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default NewFolderModal;
